import FeatureFlags from 'common/feature_flags';
import {
  VIF_CONSTANTS,
  DEFAULT_PRIMARY_COLOR
} from 'common/authoring_workflow/constants';

export default {
  format: {
    type: 'visualization_interchange_format',
    version: VIF_CONSTANTS.LATEST_VERSION
  },
  configuration: {
    viewSourceDataLink: true,
    xAxisScalingMode: 'pan'
  },
  description: '',
  series: [
    {
      color: {
        primary: DEFAULT_PRIMARY_COLOR,
        highlight: '#cccccc'
      },
      dataSource: {
        datasetUid: null,
        dimension: {
          columnName: null,
          aggregationFunction: null
        },
        measure: {
          columnName: null,
          aggregationFunction: 'count'
        },
        type: 'socrata.soql',
        filters: [],
        precision: null
      },
      label: null,
      type: 'timelineChart'
    }
  ],
  title: ''
};
